import React from 'react'
import HeaderInner from '../header/HeaderInner';
import Breadcrumb from '../inner/Breadcrumb';
import AboutOne from '../elements/AboutOne';
import WorkingProcessThree from '../elements/WorkingProcessThree';
import Team from '../elements/Team';
import TestimonialsBrand from '../elements/TestimonialsBrand';
import Footer from '../elements/Footer';
import ServicePhaseTwo from '../elements/ServicePhaseTwo';

function about() {
    return(

        <div className="index-one">

            <HeaderInner/>
        <main>
            <Breadcrumb/>
            <AboutOne/>
            <ServicePhaseTwo/>
            <WorkingProcessThree/>
            <TestimonialsBrand/>
            {/* <Team/> */}
            
            <Footer/>


        </main>


        </div>
        
    )
}

export default about